import React from 'react';
import { Link } from 'gatsby';

import { NewsletterForm } from '../Newsletter';
import { BlogCardContent } from './BlogPostCard';

const trimSlashesFromBothSides = (str) => str.replace(/^\/|\/$/g, '');

export function BlogFeaturePostCard({ featuredArticle }) {
  return (
    <div className="flex flex-col lg:flex-row flex-1 h-56 w-full p-2 bg-white rounded-[23px] overflow-hidden">
      <Link
        to={`/blog/${trimSlashesFromBothSides(featuredArticle.slug)}/`}
        className="
            bg-cover 
            bg-no-repeat
            bg-neutral-100
            aspect-video
            rounded-[13px]
            m-0
            mb-2
            lg:h-56
            lg-mb-0
            xl:h-full
          "
        style={{
          backgroundPosition: 'center',
          backgroundImage: featuredArticle.feature_image
            ? `url(https://img.paperform.co/fetch/w_1300,f_auto/${featuredArticle.feature_image})`
            : 'none',
        }}
      />

      <div className="flex flex-1 flex-col justify-start px-4 pb-3 pt-0">
        <BlogCardContent node={featuredArticle} />
      </div>
    </div>
  );
}

export function Newsletter() {
  return (
    <div className="bg-white rounded-2xl xl:h-56 w-full xl:w-72 flex flex-col items-center py-5 px-6">
      <h3 className="text-lg font-light mb-2 font-sonoma">
        Get the newsletter
      </h3>
      <p className="text-center text-sm opacity-50 mb-2">
        Like what you see? Get notified when we publish new articles.
      </p>
      <div className="mt-auto">
        <NewsletterForm />
      </div>
    </div>
  );
}

export function FeaturedBlogBanner({ featuredArticle }) {
  return (
    <div className="gap-8 flex flex-col xl:flex-row">
      {featuredArticle ? (
        <BlogFeaturePostCard featuredArticle={featuredArticle} />
      ) : null}
      <Newsletter />
    </div>
  );
}
